export default __webpack_public_path__ + "static/media/gallery_03.1ec557b5.jpg";